import { Component, OnInit } from '@angular/core';
import {KeycloakService} from "../shared/keycloak.service";
import {UserService} from "../shared/user.service";
import {Router} from "@angular/router";

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: false
})
export class HomeComponent implements OnInit {
  isAdmin = false;

  constructor(
    private kcService: KeycloakService,
    private uService: UserService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.isAdmin = this.uService.currentUser.isAdmin();
    if (!this.isAdmin) {
      this.router.navigate(['/uploader']);
    }
  }
}
